import axios from 'axios';
import Metadata from '../helpers/metadata/Metadata';
import serviceUtil from './serviceUtil';

let helpers = {
  login: (email, password) => {
    const url = process.env.REACT_APP_API + '/users/login';
    const metadata = Metadata.generateMetadatum();
    return axios({
      method: 'post',
      url: url,
      data: {
        email: email.toLowerCase(),
        password: password,
        event_metadatum: metadata,
      },
    })
      .then(response => {
        const user = response.data.user;
        
        localStorage.loggedin_user_id = user.id;
        localStorage.token = user.token;
        localStorage.primary_company_id = user.companies[0].id;
        return user;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  reissueToken: () => {
    return axios({
      method: 'get',
      url: process.env.REACT_APP_API + '/users/reissue_token?current_company=' + localStorage.current_company_id,
      headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        localStorage.token = response.data.token;
        return response.data.token;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  logout: (user_id) => {
    return axios({
      method: 'post',
      url: process.env.REACT_APP_API + '/users/destroy_token?current_company=' + localStorage.current_company_id,
      timeout: 20000,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
      data: {
        event_metadatum: Metadata.generateMetadatum(),
      },
    })
      .then(response => {
        delete localStorage.loggedin_user_id;
        delete localStorage.current_company_id;
        delete localStorage.token;
        return response.data;
      })
      .catch(error => {
        delete localStorage.loggedin_user_id;
        delete localStorage.current_company_id;
        delete localStorage.token;
        return {};
      });
  },

  // MCP OAuth (AFB-348): mint a single-use login_hint for the /oauth/authorize hop.
  // Authenticated by the existing JWT. Resolves to the login_hint string, or an
  // error result object (serviceUtil) on failure.
  mintOauthLoginCode: () => {
    return axios({
      method: 'post',
      url: process.env.REACT_APP_API + '/oauth/login_code',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => response.data.login_hint)
      .catch(error => serviceUtil.resultForError(error));
  },
};

export default helpers;




// WEBPACK FOOTER //
// ./src/services/sessionsService.js